module.exports = __webpack_public_path__ + "1098b2629353ab617069092c7e893e7b.MP3";